const TUI_HEBREW_LANGUAGE_ADDON_COMMERCE = {
  cardNumber: ['מספר', 'מספר כרטיס'],
  cardExpiry: ['פג תוקף', 'בתוקף עד']
};
const TUI_HEBREW_LANGUAGE_ADDON_EDITOR = {
  colorSelectorModeNames: ['צבע אחיד', 'מִדרוֹן'],
  toolbarTools: {
    undo: 'לבטל',
    redo: 'לַעֲשׂוֹת שׁוּב',
    font: 'גוֹפָן',
    fontStyle: 'סיגנון גופן',
    fontSize: 'גודל גופן',
    bold: 'נוֹעָז',
    italic: 'נטוי',
    underline: 'לָשִׂים דָגֵשׁ',
    strikeThrough: 'מכה דרך',
    justify: 'לְהַצְדִיק',
    justifyLeft: 'תצדיק שמאל',
    justifyCenter: 'להצדיק מרכז',
    justifyRight: 'תצדיק נכון',
    justifyFull: 'להצדיק מלא',
    list: 'רשימה',
    indent: 'לְשַׁנֵן',
    outdent: 'שקע החוצה',
    unorderedList: 'רשימה לא מסודרת',
    orderedList: 'רשימה מסודרת',
    quote: 'ציטוט',
    foreColor: 'צֶבַע',
    backColor: 'צבע רקע',
    hiliteColor: 'הדגש צבע',
    clear: 'ברור',
    link: 'קישור',
    attach: 'לצרף קובץ',
    tex: 'הכנס TeX',
    code: 'קוד',
    image: 'הוסף תמונה',
    insertHorizontalRule: 'הכנס כלל אופקי',
    superscript: 'כתב על',
    subscript: 'מנוי',
    insertTable: 'הכנס טבלה',
    insertGroup: 'הוסף קבוצה',
    hiliteGroup: 'קבוצת הילייט',
    removeGroup: 'הסר את הקבוצה',
    insertAnchor: 'הכנס עוגן',
    mergeCells: 'מיזוג תאים',
    splitCells: 'פיצול תאים',
    rowsColumnsManaging: 'ניהול שורות ועמודות',
    cellColor: 'צבע התא',
    setDetails: 'פרטים',
    removeDetails: 'הסר פרטים'
  },
  editorEditLink: {
    urlExample: 'example.com',
    anchorExample: 'לְעַגֵן'
  },
  editorTableCommands: [['הוסף עמודה לפני', 'הוסף עמודה אחרי'], ['הכנס שורה לפני', 'הכנס שורה אחרי'], ['מחק עמודה', 'מחק שורה']],
  editorCodeOptions: ['קוד בטקסט', 'קוד בבלוק'],
  editorFontOptions: {
    small: 'קָטָן',
    large: 'גָדוֹל',
    normal: 'נוֹרמָלִי',
    title: 'כותרת',
    subtitle: 'כתוביות'
  }
};
const TUI_HEBREW_LANGUAGE_ADDON_TABLE = {
  showHideText: 'הצג הסתר',
  paginationTexts: {
    pages: 'דפים',
    linesPerPage: 'שורות בעמוד',
    of: 'שֶׁל'
  }
};
const TUI_HEBREW_LANGUAGE_COUNTRIES = {
  AD: 'Andorra',
  AE: 'United Arab Emirates',
  AF: 'Afghanistan',
  AG: 'Antigua & Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AM: 'Armenia',
  AO: 'Angola',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaijan',
  BA: 'Bosnia & Herzegovina',
  BB: 'Barbados',
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BL: 'St. Barthélemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BQ: 'Caribbean Netherlands',
  BR: 'Brazil',
  BS: 'Bahamas',
  BT: 'Bhutan',
  BW: 'Botswana',
  BY: 'Belarus',
  BZ: 'Belize',
  CA: 'Canada',
  CD: 'Congo - Kinshasa',
  CF: 'Central African Republic',
  CG: 'Congo - Brazzaville',
  CH: 'Switzerland',
  CI: 'Côte d’Ivoire',
  CL: 'Chile',
  CM: 'Cameroon',
  CN: 'China',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  CV: 'Cape Verde',
  CW: 'Curaçao',
  CY: 'Cyprus',
  CZ: 'Czechia',
  DE: 'Germany',
  DJ: 'Djibouti',
  DK: 'Denmark',
  DM: 'Dominica',
  DO: 'Dominican Republic',
  DZ: 'Algeria',
  EC: 'Ecuador',
  EE: 'Estonia',
  EG: 'Egypt',
  ER: 'Eritrea',
  ES: 'Spain',
  ET: 'Ethiopia',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Federated States of Micronesia',
  FR: 'France',
  GA: 'Gabon',
  GB: 'United Kingdom',
  GD: 'Grenada',
  GE: 'Georgia',
  GF: 'French Guiana',
  GH: 'Ghana',
  GI: 'Gibraltar',
  GL: 'Greenland',
  GM: 'Gambia',
  GN: 'Guinea',
  GP: 'Guadeloupe',
  GQ: 'Equatorial Guinea',
  GR: 'Greece',
  GT: 'Guatemala',
  GW: 'Guinea-Bissau',
  GY: 'Guyana',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungary',
  ID: 'Indonesia',
  IE: 'Ireland',
  IL: 'Israel',
  IN: 'India',
  IQ: 'Iraq',
  IR: 'Iran',
  IS: 'Iceland',
  IT: 'Italy',
  JM: 'Jamaica',
  JO: 'Jordan',
  JP: 'Japan',
  KE: 'Kenya',
  KG: 'Kyrgyzstan',
  KH: 'Cambodia',
  KM: 'Comoros',
  KN: 'St. Kitts & Nevis',
  KP: 'North Korea',
  KR: 'South Korea',
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Laos',
  LB: 'Lebanon',
  LC: 'St. Lucia',
  LI: 'Liechtenstein',
  LK: 'Sri Lanka',
  LR: 'Liberia',
  LS: 'Lesotho',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LV: 'Latvia',
  LY: 'Libya',
  MA: 'Morocco',
  MC: 'Monaco',
  MD: 'Moldova',
  ME: 'Montenegro',
  MF: 'St. Martin',
  MG: 'Madagascar',
  MK: 'North Macedonia',
  ML: 'Mali',
  MM: 'Myanmar (Burma)',
  MN: 'Mongolia',
  MO: 'Macao',
  MQ: 'Martinique',
  MR: 'Mauritania',
  MS: 'Montserrat',
  MT: 'Malta',
  MU: 'Mauritius',
  MV: 'Maldives',
  MW: 'Malawi',
  MX: 'Mexico',
  MY: 'Malaysia',
  MZ: 'Mozambique',
  NA: 'Namibia',
  NC: 'New Caledonia',
  NE: 'Niger',
  NG: 'Nigeria',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NP: 'Nepal',
  NZ: 'New Zealand',
  OM: 'Oman',
  PA: 'Panama',
  PE: 'Peru',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PK: 'Pakistan',
  PL: 'Poland',
  PT: 'Portugal',
  PW: 'Palau',
  PY: 'Paraguay',
  QA: 'Qatar',
  RE: 'Réunion',
  RO: 'Romania',
  RS: 'Serbia',
  RU: 'Russia',
  RW: 'Rwanda',
  SA: 'Saudi Arabia',
  SB: 'Solomon Islands',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Sweden',
  SG: 'Singapore',
  SH: 'St. Helena',
  SI: 'Slovenia',
  SK: 'Slovakia',
  SL: 'Sierra Leone',
  SM: 'San Marino',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'São Tomé & Príncipe',
  SV: 'El Salvador',
  SX: 'Sint Maarten',
  SY: 'Syria',
  SZ: 'Eswatini',
  TC: 'Turks & Caicos Islands',
  TD: 'Chad',
  TG: 'Togo',
  TH: 'Thailand',
  TJ: 'Tajikistan',
  TL: 'Timor-Leste',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TO: 'Tonga',
  TR: 'Türkiye',
  TT: 'Trinidad & Tobago',
  TW: 'Taiwan',
  TZ: 'Tanzania',
  UA: 'Ukraine',
  UG: 'Uganda',
  US: 'United States',
  UY: 'Uruguay',
  UZ: 'Uzbekistan',
  VC: 'St. Vincent & Grenadines',
  VE: 'Venezuela',
  VG: 'British Virgin Islands',
  VN: 'Vietnam',
  VU: 'Vanuatu',
  WS: 'Samoa',
  XK: 'Kosovo',
  YE: 'Yemen',
  YT: 'Mayotte',
  ZA: 'South Africa',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  AC: 'Ascension Island',
  AS: 'American Samoa',
  AX: 'Åland Islands',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  CX: 'Christmas Island',
  EH: 'Western Sahara',
  FO: 'Faroe Islands',
  GG: 'Guernsey',
  GU: 'Guam',
  IM: 'Isle of Man',
  JE: 'Jersey',
  IO: 'British Indian Ocean Territory',
  KI: 'Kiribati',
  MH: 'Marshall Islands',
  MP: 'Northern Mariana Islands',
  NF: 'Norfolk Island',
  NR: 'Nauru',
  NU: 'Niue',
  PM: 'Saint Pierre and Miquelon',
  PR: 'Puerto Rico',
  PS: 'Palestine',
  SJ: 'Svalbard and Jan Mayen',
  SS: 'South Sudan',
  TA: 'Tristan da Cunha',
  TK: 'Tokelau',
  TV: 'Tuvalu',
  VA: 'Holy See',
  VI: 'Virgin Islands',
  WF: 'Wallis and Futuna'
};
const TUI_HEBREW_LANGUAGE_CORE = {
  months: ['יָנוּאָר', 'פברואר', 'מרץ', 'אַפּרִיל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'סֶפּטֶמבֶּר', 'אוֹקְטוֹבֶּר', 'נוֹבֶמבֶּר', 'דֵצֶמבֶּר'],
  close: 'סגור',
  clear: 'נקה שדה',
  nothingFoundMessage: 'שום דבר לא נמצא',
  defaultErrorMessage: 'הערך לא חוקי',
  spinTexts: ['קודם', 'הַבָּא'],
  shortWeekDays: ['יום שני', "ג'", 'היינו עושים', "יום ה'", 'שישי', 'ישב', 'שמש'],
  countries: TUI_HEBREW_LANGUAGE_COUNTRIES
};
const TUI_HEBREW_LANGUAGE_KIT = {
  cancel: 'לְבַטֵל',
  done: 'בוצע',
  more: 'יותר',
  otherDate: 'תאריך אחר',
  showAll: 'הצג הכול',
  hide: 'להתחבא',
  mobileCalendarTexts: ['בחר יום', 'בחר טווח', 'בחר ימים'],
  range: ['מ', 'ל'],
  countTexts: ['ועוד', 'מִינוּס'],
  time: {
    'HH:MM': 'HH:MM',
    'HH:MM AA': 'HH:MM AA',
    'HH:MM:SS': 'HH:MM:SS',
    'HH:MM:SS AA': 'HH:MM:SS AA',
    'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
    'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA'
  },
  dateTexts: {
    DMY: 'dd/mm/yyyy',
    MDY: 'mm/dd/yyyy',
    YMD: 'yyyy/mm/dd'
  },
  digitalInformationUnits: ['B', 'KiB', 'MiB'],
  passwordTexts: ['הראה סיסמה', 'הסתר סיסמא'],
  copyTexts: ['עותק', 'מוּעֲתָק'],
  shortCalendarMonths: ['ינואר', 'פברואר', 'לְקַלְקֵל', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
  pagination: ['עמוד קודם', 'עמוד הבא'],
  fileTexts: {
    loadingError: 'העלאה נכשלה',
    preview: 'תצוגה מקדימה',
    remove: 'לְהַסִיר'
  },
  inputFileTexts: {
    defaultLabelSingle: 'או לרדת\u00A0זה\u00A0כאן',
    defaultLabelMultiple: 'או לרדת\u00A0אוֹתָם\u00A0כאן',
    defaultLinkSingle: 'בחר קובץ',
    defaultLinkMultiple: 'לבחור קבצים',
    maxSizeRejectionReason: 'הקובץ גדול מ',
    formatRejectionReason: 'סוג קובץ שגוי',
    drop: 'שחרר את הקובץ כאן',
    dropMultiple: 'זרוק קבצים כאן'
  },
  multiSelectTexts: {
    all: 'בחר הכל',
    none: 'אל תבחר באף אחת מהאפשרויות'
  },
  confirm: {
    yes: 'כן',
    no: 'לא'
  },
  previewTexts: {
    rotate: 'להתחלף'
  },
  zoomTexts: {
    zoomOut: 'להקטין את התצוגה',
    zoomIn: 'לְהִתְמַקֵד',
    reset: 'אִתחוּל'
  },
  phoneSearch: 'הקלד מדינה או קוד'
};
const TUI_HEBREW_LANGUAGE_LAYOUT = {
  inputSearch: {
    popular: 'Popular',
    history: 'Recent',
    placeholder: 'Type query',
    hotkey: 'to search',
    all: 'All',
    empty: 'Nothing found'
  }
};
const TUI_HEBREW_LANGUAGE = {
  name: 'hebrew',
  ...TUI_HEBREW_LANGUAGE_CORE,
  ...TUI_HEBREW_LANGUAGE_KIT,
  ...TUI_HEBREW_LANGUAGE_ADDON_TABLE,
  ...TUI_HEBREW_LANGUAGE_ADDON_COMMERCE,
  ...TUI_HEBREW_LANGUAGE_ADDON_EDITOR,
  ...TUI_HEBREW_LANGUAGE_LAYOUT
};

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_HEBREW_LANGUAGE, TUI_HEBREW_LANGUAGE_ADDON_COMMERCE, TUI_HEBREW_LANGUAGE_ADDON_EDITOR, TUI_HEBREW_LANGUAGE_ADDON_TABLE, TUI_HEBREW_LANGUAGE_CORE, TUI_HEBREW_LANGUAGE_COUNTRIES, TUI_HEBREW_LANGUAGE_KIT, TUI_HEBREW_LANGUAGE_LAYOUT };
